var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-template-manage-container" },
    [
      _c(
        "el-card",
        { staticClass: "scene-control-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "config-options" },
                [
                  _c("el-input", {
                    staticClass: "filter-item",
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "门店名称", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleStoreFilter($event)
                      },
                    },
                    model: {
                      value: _vm.storeQuery.keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.storeQuery, "keywords", $$v)
                      },
                      expression: "storeQuery.keywords",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleStoreFilter },
                    },
                    [_vm._v("\n          搜索\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-content" },
            [
              _c(
                "el-row",
                { staticClass: "tac" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-vertical-demo",
                          attrs: { "default-openeds": ["100"] },
                          on: { select: _vm.handleStoreSelect },
                        },
                        [
                          _c(
                            "el-submenu",
                            { attrs: { index: "100" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleStoreSelect(-1)
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("全部门店")])]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.storeData, function (item) {
                                return _c(
                                  "el-menu-item-group",
                                  { key: item.label },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(_vm._s(item.label)),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(item.children, function (detail) {
                                      return _c(
                                        "el-menu-item",
                                        {
                                          key: detail.storeId,
                                          attrs: { index: "" + detail.storeId },
                                        },
                                        [_vm._v(_vm._s(detail.label))]
                                      )
                                    }),
                                  ],
                                  2
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      attrs: { span: 20 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            { name: "waves", rawName: "v-waves" },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.addGoodsUnitForm.storeId != null,
                              expression: "addGoodsUnitForm.storeId != null",
                            },
                          ],
                          staticClass: "filter-item",
                          staticStyle: { margin: "10px" },
                          attrs: { type: "primary", icon: "el-icon-plus" },
                          on: { click: _vm.handleAddGoodsUnit },
                        },
                        [_vm._v("\n            增加规格\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            "font-size": "14px",
                            color: "#606266",
                            "font-weight": "600",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.goodsName) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.goodsUnitDataList, function (unit) {
                        return _c(
                          "span",
                          { staticClass: "group-block" },
                          [
                            _c("div", { staticClass: "group-header" }, [
                              _c(
                                "div",
                                { staticClass: "group-title" },
                                [
                                  _vm._v(
                                    "\n            单位:" +
                                      _vm._s(unit.unitName) +
                                      "\n              \n             默认:\n            "
                                  ),
                                  _c("el-switch", {
                                    attrs: {
                                      "active-color": "#13ce66",
                                      "inactive-color": "#ff4949",
                                      "active-value": 1,
                                      "inactive-value": 0,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleDefaultFlag(
                                          unit.id,
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: unit.defaultFlag,
                                      callback: function ($$v) {
                                        _vm.$set(unit, "defaultFlag", $$v)
                                      },
                                      expression: "unit.defaultFlag",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "group-time" }, [
                                _vm._v(
                                  "\n            价格:¥ " +
                                    _vm._s(unit.price) +
                                    "\n            "
                                ),
                                unit.storeId !== -1
                                  ? _c(
                                      "span",
                                      [
                                        _vm._v(
                                          "\n               展示:\n            "
                                        ),
                                        _c("el-switch", {
                                          attrs: {
                                            "active-color": "#13ce66",
                                            "inactive-color": "#ff4949",
                                            "active-value": 1,
                                            "inactive-value": 0,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleDisplayFlag(
                                                unit.id,
                                                "goodsUnit",
                                                $event
                                              )
                                            },
                                          },
                                          model: {
                                            value: unit.displayFlag,
                                            callback: function ($$v) {
                                              _vm.$set(unit, "displayFlag", $$v)
                                            },
                                            expression: "unit.displayFlag",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "group-actions" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "primary",
                                        icon: "el-icon-edit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleGoodsUnitEdit(unit)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              编辑\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "primary",
                                        icon: "el-icon-plus",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleAddGoodsMakeMethod(
                                            unit.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              添加做法\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        icon: "el-icon-delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleGoodsUnitDelete(
                                            unit.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              删除\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.listLoading,
                                    expression: "listLoading",
                                  },
                                ],
                                key: unit.id,
                                ref: "table_" + unit.id,
                                refInFor: true,
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: unit.makeMethodTree,
                                  stripe: "",
                                  border: "",
                                  fit: "",
                                  "highlight-current-row": "",
                                  "row-key": _vm.getRowKey,
                                  "tree-props": {
                                    children: "children",
                                    hasChildren: "hasChildren",
                                  },
                                },
                                on: {
                                  "sort-change": function ($event) {
                                    return _vm.handleTableSortChange(
                                      $event,
                                      _vm.detail
                                    )
                                  },
                                  "selection-change": function (selection) {
                                    return _vm.handleSelectionChange(
                                      selection,
                                      _vm.detail
                                    )
                                  },
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { type: "selection", width: "55" },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "序号",
                                    prop: "data.id",
                                    align: "center",
                                    width: "100",
                                    sortable: "custom",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "名称",
                                    prop: "data.name",
                                    align: "center",
                                    "min-width": "120",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "POS编码",
                                    prop: "data.code",
                                    align: "center",
                                    width: "120",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "价格",
                                    align: "center",
                                    width: "120",
                                    prop: "price",
                                    sortable: "custom",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var row = ref.row
                                          return [
                                            row.data.displayFlag != null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(row.data.price)
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "排序",
                                    align: "center",
                                    width: "120",
                                    prop: "price",
                                    sortable: "custom",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var row = ref.row
                                          return [
                                            _c("el-input", {
                                              attrs: {
                                                type: "number",
                                                placeholder: "排序",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.handleSortChange(
                                                    row.data,
                                                    row
                                                  )
                                                },
                                              },
                                              nativeOn: {
                                                keyup: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.handleSortChange(
                                                    row.data,
                                                    row
                                                  )
                                                },
                                              },
                                              model: {
                                                value: row.data.sort,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row.data,
                                                    "sort",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.data.sort",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "展示",
                                    align: "center",
                                    width: "120",
                                    prop: "price",
                                    sortable: "custom",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var row = ref.row
                                          return [
                                            row.data.displayFlag != null
                                              ? _c("el-switch", {
                                                  attrs: {
                                                    "active-color": "#13ce66",
                                                    "inactive-color": "#ff4949",
                                                    "active-value": 1,
                                                    "inactive-value": 0,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleDisplayFlag(
                                                        row.data.id,
                                                        "goodsMakeMethod",
                                                        $event
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: row.data.displayFlag,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row.data,
                                                        "displayFlag",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "row.data.displayFlag",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t("tableFrom.Operation"),
                                    align: "center",
                                    width: "250",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var row = ref.row
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "danger",
                                                      icon: "el-icon-delete",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleMakeMethodDelete(
                                                          row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  删除\n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            title: _vm.addGoodsUnitForm.id ? "编辑规格" : "增加规格",
            visible: _vm.addGoodsUnitVisible,
            size: "500px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addGoodsUnitVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addGoodsUnitFormRef",
              staticClass: "dialog-form",
              attrs: {
                model: _vm.addGoodsUnitForm,
                rules: _vm.addGoodsUnitRules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规格", prop: "unitId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        filterable: "",
                        placeholder: "请选择规格",
                        clearable: "",
                      },
                      model: {
                        value: _vm.addGoodsUnitForm.unitId,
                        callback: function ($$v) {
                          _vm.$set(_vm.addGoodsUnitForm, "unitId", $$v)
                        },
                        expression: "addGoodsUnitForm.unitId",
                      },
                    },
                    _vm._l(_vm.unitList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.unitName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "规格价格", prop: "price" } },
                [
                  _vm._v("\n        ¥"),
                  _c("el-input", {
                    staticStyle: { width: "190px" },
                    attrs: { type: "number", placeholder: "请输入规格价格" },
                    model: {
                      value: _vm.addGoodsUnitForm.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.addGoodsUnitForm, "price", $$v)
                      },
                      expression: "addGoodsUnitForm.price",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "190px" },
                    attrs: { type: "number", placeholder: "请输入排序" },
                    model: {
                      value: _vm.addGoodsUnitForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.addGoodsUnitForm, "sort", $$v)
                      },
                      expression: "addGoodsUnitForm.sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addGoodsUnitVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveGoodsUnit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            title: "增加做法",
            visible: _vm.addGoodsMakeMethodVisible,
            size: "500px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addGoodsMakeMethodVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addGoodsMakeMethodFormRef",
              staticClass: "dialog-form",
              attrs: {
                model: _vm.addGoodsMakeMethodForm,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "做法", prop: "title" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      "show-all-levels": false,
                      placeholder: "请选择做法",
                      options: _vm.makeMethods,
                      props: {
                        value: "id",
                        leaf: "leaf",
                        multiple: true,
                        emitPath: false,
                      },
                    },
                    model: {
                      value: _vm.addGoodsMakeMethodForm.makeMethodIds,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.addGoodsMakeMethodForm,
                          "makeMethodIds",
                          $$v
                        )
                      },
                      expression: "addGoodsMakeMethodForm.makeMethodIds",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addGoodsMakeMethodVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveGoodsMakeMethod },
                },
                [_vm._v("添加")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }